import React from 'react'

function MultiTourList() {
  return (
    <div className="content-section tour-list">
        <div className="container multi-tour-list">
            <h2 className="sub-title">Multi Tour List</h2>
        </div>
    </div>
  )
}

export default MultiTourList